/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClinicApplicationDocsOut } from './ClinicApplicationDocsOut';
import {
    ClinicApplicationDocsOutFromJSON,
    ClinicApplicationDocsOutFromJSONTyped,
    ClinicApplicationDocsOutToJSON,
} from './ClinicApplicationDocsOut';
import type { ClinicInfoOut } from './ClinicInfoOut';
import {
    ClinicInfoOutFromJSON,
    ClinicInfoOutFromJSONTyped,
    ClinicInfoOutToJSON,
} from './ClinicInfoOut';
import type { DoctorApplicationDocsOut } from './DoctorApplicationDocsOut';
import {
    DoctorApplicationDocsOutFromJSON,
    DoctorApplicationDocsOutFromJSONTyped,
    DoctorApplicationDocsOutToJSON,
} from './DoctorApplicationDocsOut';
import type { DoctorInfoOut } from './DoctorInfoOut';
import {
    DoctorInfoOutFromJSON,
    DoctorInfoOutFromJSONTyped,
    DoctorInfoOutToJSON,
} from './DoctorInfoOut';
import type { SubscriptionInfoOut } from './SubscriptionInfoOut';
import {
    SubscriptionInfoOutFromJSON,
    SubscriptionInfoOutFromJSONTyped,
    SubscriptionInfoOutToJSON,
} from './SubscriptionInfoOut';
import type { DoctorSchema } from './DoctorSchema';
import {
    DoctorSchemaFromJSON,
    DoctorSchemaFromJSONTyped,
    DoctorSchemaToJSON,
} from './DoctorSchema';

/**
 * 
 * @export
 * @interface DataOut
 */
export interface DataOut {
    /**
     *
     * @type {DoctorInfoOut}
     * @memberof DataOut
     */
    doctorInfo?: DoctorInfoOut;
    /**
     * 
     * @type {ClinicInfoOut}
     * @memberof DataOut
     */
    clinicInfo?: ClinicInfoOut;
    /**
     * 
     * @type {Array<SubscriptionInfoOut>}
     * @memberof DataOut
     */
    subscriptionInfo?: Array<SubscriptionInfoOut>;
    /**
     * 
     * @type {Array<DoctorApplicationDocsOut>}
     * @memberof DataOut
     */
    doctorDocs?: Array<DoctorApplicationDocsOut>;
    /**
     * 
     * @type {Array<ClinicApplicationDocsOut>}
     * @memberof DataOut
     */
    clinicDocs?: Array<ClinicApplicationDocsOut>;
    /**
     * 
     * @type {boolean}
     * @memberof DataOut
     */
    isJunior?: boolean;
}

/**
 * Check if a given object implements the DataOut interface.
 */
export function instanceOfDataOut(value: object): boolean {
    return true;
}

export function DataOutFromJSON(json: any): DataOut {
    return DataOutFromJSONTyped(json, false);
}

export function DataOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataOut {
    if (json == null) {
        return json;
    }
    return {

        'doctorInfo': json['doctor_info'] == null ? undefined : DoctorInfoOutFromJSON(json['doctor_info']),
        'clinicInfo': json['clinic_info'] == null ? undefined : ClinicInfoOutFromJSON(json['clinic_info']),
        'subscriptionInfo': json['subscription_info'] == null ? undefined : ((json['subscription_info'] as Array<any>).map(SubscriptionInfoOutFromJSON)),
        'doctorDocs': json['doctor_docs'] == null ? undefined : ((json['doctor_docs'] as Array<any>).map(DoctorApplicationDocsOutFromJSON)),
        'clinicDocs': json['clinic_docs'] == null ? undefined : ((json['clinic_docs'] as Array<any>).map(ClinicApplicationDocsOutFromJSON)),
        'isJunior': json['is_junior'] == null ? undefined : json['is_junior'],
    };
}

export function DataOutToJSON(value?: DataOut | null): any {
    if (value == null) {
        return value;
    }
    return {

        'doctor_info': DoctorInfoOutToJSON(value['doctorInfo']),
        'clinic_info': ClinicInfoOutToJSON(value['clinicInfo']),
        'subscription_info': value['subscriptionInfo'] == null ? undefined : ((value['subscriptionInfo'] as Array<any>).map(SubscriptionInfoOutToJSON)),
        'doctor_docs': value['doctorDocs'] == null ? undefined : ((value['doctorDocs'] as Array<any>).map(DoctorApplicationDocsOutToJSON)),
        'clinic_docs': value['clinicDocs'] == null ? undefined : ((value['clinicDocs'] as Array<any>).map(ClinicApplicationDocsOutToJSON)),
        'is_junior': value['isJunior'],
    };
}

